import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
    (theme) => ({
         section: {
            marginTop: theme.spacing(2),
            padding: theme.spacing(2),
            border: '1px solid #e0e0e0',
            borderRadius: 8,
            backgroundColor: '#fafafa',
            '@media print': {
                marginTop: theme.spacing(1.5),
                padding: theme.spacing(1.5),
                breakInside: 'avoid',
            },
        },
        title: {
            fontSize: '0.9rem',
            fontWeight: 700,
            color: theme.palette.primary.main,
            marginBottom: theme.spacing(1.5),
            textTransform: 'uppercase',
            borderBottom: `2px solid ${theme.palette.primary.main}`,
            display: 'inline-block',
            paddingBottom: 2,
        },
        label: {
            fontSize: '0.75rem',
            color: '#666',
            fontWeight: 500,
        },
        value: {
            fontSize: '0.85rem',
            fontWeight: 600,
            color: '#333',
        },
        itemContainer: {
            marginBottom: theme.spacing(1),
        },
        highlightValue: {
            color: 'darkblue',
            fontWeight: 700,
        }
    })
);

export default useStyles;